import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

import {gradient3} from 'src/assets/images'
interface Props {
  bk?: string
  gradientbk?: string
  content: () => ReactJSXElement
}

const ContentSection = ({
  bk,
  gradientbk = gradient3,
  content: Content,
}: Props) => {
  return (
    <section>
      <Box
        sx={{
          pb: 0,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundImage: `url(${gradientbk})`,
        }}
      >
        <Box
          sx={{
            background: `url(${bk});`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto 100%',
            backgroundPosition: 'top right',
            py: 14,
          }}
        >
          <Container maxWidth="lg">
            <Content />
          </Container>
        </Box>
      </Box>
    </section>
  )
}

export default ContentSection
